import * as L from 'leaflet';
import { AriaLabelDivIcon } from './aria-label-div-icon';

export class ButtonDivIcon extends AriaLabelDivIcon {
  constructor(options: L.DivIconOptions, ariaLabel: string | undefined = undefined) {
    super(options, ariaLabel);
  }

  // See https://leafletjs.com/reference-1.7.1.html#divicon-option
  createIcon(oldIcon?: HTMLElement): HTMLElement {
    const icon = AriaLabelDivIcon.prototype.createIcon.call(this, oldIcon);
    icon.setAttribute('role', 'button');
    return icon;
  }
}
